import { alias, deserialize, identifier, serializable } from "serializr";
import { IJsonObject } from "../api";

interface IProps {
	id?: number;
	fileSize?: number;
	filename?: string;
	mime?: string;
	attachableId?: number;
}

export class Attachment {
	public static fromJson(json: IJsonObject): Attachment {
		return deserialize(Attachment, json);
	}

	public static fromJsonArray(json: IJsonObject[]): Attachment[] {
		return json.map((user: IJsonObject) => this.fromJson(user));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable(alias("bodylength"))
	public fileSize: number;

	@serializable(alias("attachable_id"))
	public attachableId: number;

	@serializable
	public filename: string;

	@serializable
	public mime: string;

	constructor({
		id = 0,
		fileSize = 0,
		filename = "",
		mime = "",
		attachableId = 0,
	}: IProps = {}) {
		this.id = id;
		this.fileSize = fileSize;
		this.filename = filename;
		this.mime = mime;
		this.attachableId = attachableId;
	}

	public isImage(): boolean {
		const acceptedImageTypes = ["image/gif", "image/jpeg", "image/png"];
		if (acceptedImageTypes.includes(this.mime)) {
			return true;
		}

		return false;
	}
}
